import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69a627df"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"bg-greenLight flex items-center flex-col laptop:flex-row\" data-v-69a627df><div class=\"w-full h-[300px] laptop:h-[500px] laptop:w-1/2 laptop:mt-[30px] laptop:mb-[-40px]\" id=\"image\" data-v-69a627df><img src=\"obrazky/zavody/esg.jpg\" alt=\"\" class=\"h-full object-cover w-full shadow-xl rounded-r\" data-v-69a627df></div><div class=\"flex flex-col gap-10 laptop:w-1/2 px-[10%] laptop:px-[5%] py-5 justify-center\" data-v-69a627df><h3 class=\"text-blue text-lg font-semibold px-[5%]\" data-v-69a627df>Historie oddílu</h3><p data-v-69a627df>Klub <strong data-v-69a627df>SK TRASKO Vyškov </strong>byl založen v lednu 2000 pod původním názvem SK QUANTUM MONTÁŽE Vyškov. U jeho založení stála MUDr.Kateřina Kapounková. Od počátku existence je klub registrován u ČSMG v Praze. Na základě přání hlavního sponzora došlo v prosinci téhož roku ke změně názvu na SK TRASKO VYŠKOV. Kvalitní zázemí našel klub na ZŠ Purkyňova.</p><p data-v-69a627df>SK TRASKO VYŠKOV sdružuje děvčata z Vyškova a okolí, která ve věnují cvičení a závodění dle <a class=\"text-green underline\" href=\"https://www.csmg.cz/\" target=\"_blank\" data-v-69a627df>pravidel moderní gymnastiky (jednotlivkyně i společné skladby) </a>a dle <a class=\"text-green underline\" href=\"https://csesg.cz/\" target=\"_blank\" data-v-69a627df>pravidel estetické skupinové gymnastiky (ESG)</a>. Jsme hodnoceni opakovaně jako jeden z nejúspěšnějších sportovních oddílů Vyškova. Nové členky jsou vítány.</p></div></div>", 1)
const _hoisted_2 = { class: "flex flex-col laptop:flex-row laptop:justify-between laptop:px-[5%] desktop:px-[10%] py-28" }
const _hoisted_3 = { class: "text-lg py-5 font-semibold" }
const _hoisted_4 = { class: "px-2 text-left" }
const _hoisted_5 = { class: "flex flex-col bg-grayLight px-12 py-16 laptop:flex-row" }
const _hoisted_6 = { class: "flex flex-col laptop:w-1/2 laptop:px-12" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-blue text-xl font-semibold p-6" }, "Sportovní akademie", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center items-center text-bluDark" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Sportovní akademie (dále jen „SA“) je určena pro talentované moderní gymnastky ve věku 6 až 13 let. Jejím posláním je vytvoření podmínek pro rozvoj moderní gymnastiky v dané oblasti a systematická, dlouhodobá sportovní příprava gymnastek na přechod do SpS")
], -1))
const _hoisted_9 = { class: "flex flex-col" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-lg py-5 font-semibold text-blue" }, "Členky SA", -1))
const _hoisted_11 = { class: "flex flex-col laptop:w-1/2 laptop:px-12" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-blue text-xl font-semibold p-6" }, "Družstvo nadějí", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center items-center text-blueDark" }, [
  /*#__PURE__*/_createElementVNode("p", null, "V našem oddílu máme také gymnastky, které jsou členkami družstva nadějí.")
], -1))
const _hoisted_14 = { class: "flex flex-col" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tex-lg py-5 font-semibold text-blue" }, "Členky Družstva nadějí", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full h-[100px] bg-grayLight" }, null, -1))

import {JudgesList} from "@/interfaces/interfaces";
import judges from "../../public/data/rozhodci";
import coaches from "../../public/data/trenerky";
import judgesESG from "../../public/data/rozhodciESG";
import SAmembers from "../../public/data/clenkySA";
import clenkyDruzstvaNadeji from "../../public/data/clenkyDruzstvaNadeji";



export default /*#__PURE__*/_defineComponent({
  setup(__props) {


const coachesAndJudgesLists : JudgesList[] = [
  {
    list: coaches,
    heading: 'Trenéři',
    color: 'text-green'
  } as JudgesList,
  {
    list: judges,
    heading: 'Rozhodčí',
    color: 'text-orange'
  } as JudgesList,
  {
    list: judgesESG,
    heading: 'Rozhodčí ESG',
    color: 'text-blue'
  } as JudgesList,

]


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(coachesAndJudgesLists, (list) => {
        return _createElementVNode("ul", {
          class: "flex flex-col ml-auto mr-auto",
          key: list.heading
        }, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(list.heading), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.list, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.name,
              class: "flex"
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(["px-2 font-semibold text-left", list.color])
              }, _toDisplayString(item.level), 3),
              _createElementVNode("span", _hoisted_4, _toDisplayString(item.degree) + " " + _toDisplayString(item.name), 1)
            ]))
          }), 128))
        ])
      }), 64))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _hoisted_8,
        _createElementVNode("ul", _hoisted_9, [
          _hoisted_10,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(SAmembers), (member) => {
            return (_openBlock(), _createElementBlock("li", {
              key: member.name,
              class: "py-1 text-gray-500"
            }, _toDisplayString(member.name), 1))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _hoisted_13,
        _createElementVNode("ul", _hoisted_14, [
          _hoisted_15,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(clenkyDruzstvaNadeji), (member) => {
            return (_openBlock(), _createElementBlock("li", {
              key: member.name,
              class: "py-1 text-gray-500"
            }, _toDisplayString(member.name), 1))
          }), 128))
        ])
      ])
    ]),
    _hoisted_16
  ], 64))
}
}

})